module.exports = "/_next/static/images/logo-20cdc338e8acf2de6299644e4f24b6e7.png";